import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import { IconButton } from "@mui/material";
import {
  Home,
  ImageSearch,
  People,
  Podcasts,
  Widgets,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function MYDRAWER({ mode }) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const navigate = useNavigate();

  const DrawerList = (
    <Box
      sx={{
        width: 250,
        height: "100%", // Ensure full height
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between", // Space out the list items and footer
        p: 2,
        backgroundColor: (theme) => theme.palette.background.paper, // Match the theme's background color
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/home")}>
            <ListItemIcon sx={{ color: "#e84545" }}>
              <Home />
            </ListItemIcon>
            <ListItemText primary={"Home"} />
          </ListItemButton>
        </ListItem> 
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/portfolio")}>
            <ListItemIcon sx={{ color: "#e84545" }}>
              <ImageSearch />
            </ListItemIcon>
            <ListItemText primary={"Projects"} />
          </ListItemButton>
        </ListItem>
      
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/posts")}>
            <ListItemIcon sx={{ color: "#e84545" }}>
              <Podcasts />
            </ListItemIcon>
            <ListItemText primary={"Posts"} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/Team")}>
            <ListItemIcon sx={{ color: "#e84545" }}>
              <People />
            </ListItemIcon>
            <ListItemText primary={"Team"} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/contacts")}>
            <ListItemIcon sx={{ color: "#e84545" }}>
              <MailIcon />
            </ListItemIcon>
            <ListItemText primary={"Contacts"} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <div>
      <IconButton
        onClick={toggleDrawer(true)}
        sx={{ marginRight:'4rem',zIndex: 1200, color: mode === "light" ? "#e84545" : "#fff" }} // Ensure the menu icon is above other elements
      >
        <Widgets id="icoonmenuo" />
      </IconButton>
      <Drawer
        sx={{
          zIndex: 1300, // Ensure the drawer is above the header and other elements
          "& .MuiDrawer-paper": {
            zIndex: 1300, // Ensure the drawer's paper is above other elements
          },
        }}
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
      >
        {DrawerList}
      </Drawer>
    </div>
  );
}
